import { EntitySelectorsFactory } from '@ngrx/data';

import { SubActividadEspecie } from './sub-actividades-especie.model';

export const subActividadesEspecieSelectors =
  new EntitySelectorsFactory().create<SubActividadEspecie>('SubActividadEspecie');

export const selectAllSubActividadesEspecie = subActividadesEspecieSelectors.selectEntities;